import { Typography } from "antd";
import { useEffect, useState } from "react";
import { parseInline, parseMarkdown } from "./markdown";
import "./how-to-start-page.css";

const GUIDE_URL = "/help/how-to-start/README.md";

const Inline = ({ text }) => (
  <>
    {parseInline(text).map((token, index) => {
      if (token.type === "strong") return <strong key={index}>{token.value}</strong>;
      if (token.type === "code") return <code key={index}>{token.value}</code>;
      if (token.type === "link") {
        return (
          <a key={index} href={token.href} target="_blank" rel="noreferrer">
            {token.value}
          </a>
        );
      }
      if (token.type === "image") {
        return <img key={index} src={token.src} alt={token.alt} className="help-figure-img" />;
      }
      return <span key={index}>{token.value}</span>;
    })}
  </>
);

const HowToStartPage = () => {
  const [blocks, setBlocks] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetch(GUIDE_URL)
      .then((response) => {
        if (!response.ok) throw new Error("not found");
        return response.text();
      })
      .then((text) => {
        if (!cancelled) setBlocks(parseMarkdown(text));
      })
      .catch(() => {
        if (!cancelled) setError("Не удалось загрузить инструкцию.");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <article className="help-page">
      {error ? <Typography.Paragraph type="danger">{error}</Typography.Paragraph> : null}
      {!error && !blocks ? <Typography.Paragraph type="secondary">Загрузка…</Typography.Paragraph> : null}
      {blocks?.map((block, index) => {
        if (block.type === "heading") {
          return (
            <Typography.Title key={index} level={Math.min(block.level, 3)} className="help-heading">
              <Inline text={block.text} />
            </Typography.Title>
          );
        }
        if (block.type === "paragraph") {
          return (
            <Typography.Paragraph key={index} className="help-prose">
              <Inline text={block.text} />
            </Typography.Paragraph>
          );
        }
        if (block.type === "image") {
          return (
            <figure key={index} className="help-figure">
              <img src={block.src} alt={block.alt} className="help-figure-img" />
              {block.alt ? <figcaption>{block.alt}</figcaption> : null}
            </figure>
          );
        }
        if (block.type === "table") {
          return (
            <div key={index} className="help-table-wrap">
              <table className="help-table">
                <thead>
                  <tr>
                    {block.head.map((cell, cellIndex) => (
                      <th key={cellIndex}>
                        <Inline text={cell} />
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {block.rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex}>
                          <Inline text={cell} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          );
        }
        return <hr key={index} className="help-hr" />;
      })}
    </article>
  );
};

export default HowToStartPage;
